import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faComments,
  faFileContract,
  faHandshake,
  faReceipt,
  faRightFromBracket,
  faUserCircle,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { hasAdminGroup } from '../../auth/admin';
import welcomeGraphic from '../../assets/images/member-welcome.png';
import './index.css';

const MemberWelcome = () => {
  const { logout, profile } = useAuth();
  const navigate = useNavigate();
  const canViewAdmin = hasAdminGroup(profile?.groups);
  const firstName = profile?.name?.trim().split(/\s+/)[0];

  const handleLogout = async () => {
    await logout();
    navigate('/', { replace: true });
  };

  return (
    <section className="member-welcome-page">
      <div className="member-welcome-hero">
        <div className="member-welcome-copy">
          <p>Member home</p>
          <h1>Welcome to Hogcloud{firstName ? `, ${firstName}` : ''}!</h1>
          <span>
            Your member tools keep orders, proposals, meetings, and account details
            together in one place. You can return to these options anytime from the
            profile navigation menu at the top of the page.
          </span>
        </div>
        <img src={welcomeGraphic} alt="Friendly cloud technology workspace illustration" />
      </div>

      <nav className="member-welcome-nav" aria-label="Member navigation">
        <Link to="/#arkiebyte"><FontAwesomeIcon icon={faComments} />Chat With Us</Link>
        <Link to="/profile"><FontAwesomeIcon icon={faUserCircle} />Profile</Link>
        <Link to="/orders"><FontAwesomeIcon icon={faReceipt} />Orders</Link>
        <Link to="/proposals"><FontAwesomeIcon icon={faFileContract} />Proposals</Link>
        <Link to="/meetings"><FontAwesomeIcon icon={faHandshake} />Meetings</Link>
        {canViewAdmin && <Link to="/admin"><FontAwesomeIcon icon={faUserShield} />Admin</Link>}
        <button type="button" onClick={handleLogout}><FontAwesomeIcon icon={faRightFromBracket} />Logout</button>
      </nav>

      <div className="member-welcome-features">
        <article>
          <FontAwesomeIcon icon={faReceipt} />
          <div><h2>Track your work</h2><p>Review order history, status, item details, and available invoices.</p></div>
        </article>
        <article>
          <FontAwesomeIcon icon={faFileContract} />
          <div><h2>Keep documents close</h2><p>Access project proposals and secure downloads prepared for your account.</p></div>
        </article>
        <article>
          <FontAwesomeIcon icon={faHandshake} />
          <div><h2>Manage meetings</h2><p>See scheduled conversations and manage upcoming appointments with Hogcloud.</p></div>
        </article>
        <article>
          <FontAwesomeIcon icon={faUserCircle} />
          <div><h2>Maintain your profile</h2><p>Keep contact, company, address, and account preferences current.</p></div>
        </article>
      </div>
    </section>
  );
};

export default MemberWelcome;
